import { memo } from 'react';
import styles from './index.module.scss';
import titlePng from '@/assets/images/title_icon.png';
import { Progress } from 'antd';
import { useRequest } from 'ahooks';
import { apiV2ElectricMapDataStrategyPost } from '@maxtropy/device-customer-apis-v2';
import { Empty } from '@maxtropy/components';
import classNames from 'classnames';

enum LoadType {
  LOW = 1,
  MIDDLE = 2,
  HIGH = 3,
  HIGHEST = 4,
}

const LoadNum = {
  [LoadType.LOW]: 50,
  [LoadType.MIDDLE]: 60,
  [LoadType.HIGH]: 70,
  [LoadType.HIGHEST]: 80,
};

const LoadColor = {
  [LoadType.LOW]: '#5BFF60',
  [LoadType.MIDDLE]: '#52E7FF',
  [LoadType.HIGH]: '#FFCB47',
  [LoadType.HIGHEST]: '#FF4D4F',
};

const LoadText = {
  [LoadType.LOW]: '请关注本月需量变化趋势，提前规划负荷分流。',
  [LoadType.MIDDLE]: '需量达到近期高点，存在容需量电费上升风险，请检查空压站、变电站负载，适时进行需量调控。',
  [LoadType.HIGH]: '需量触达历史高位，为控制电费成本、缓解供电压力，请及时对空压站、变电站负载进行负荷调控。',
  [LoadType.HIGHEST]: '请立即进行负荷分流与调控，并分析高负载原因，确保系统安全。',
};

interface SchedulingPolicyProps {
  isCompactMode?: boolean;
}

const SchedulingPolicy: React.FC<SchedulingPolicyProps> = ({ isCompactMode }) => {
  const { data: overviewData, loading: overviewLoading } = useRequest(() =>
    apiV2ElectricMapDataStrategyPost({}).then(res => {
      return res.list;
    })
  );

  return (
    <div className={classNames(styles.container, isCompactMode && styles.compactContainer)}>
      <div className={styles.policy}>
        <div className={styles.titleHeader}>
          <img src={titlePng} alt="" />
          <div>调度策略</div>
        </div>
        {(overviewData ?? []).length === 0 ? (
          <div className={styles.status}>
            <div className={styles.outerCircle}>
              <div className={styles.rotateRing}></div>
              <div className={styles.innerDiamonds}></div>
            </div>
            <div>本月全厂供电系统整体运行平稳，系统安全可靠。</div>
          </div>
        ) : (
          <div className={styles.dataList}>
            {(overviewData ?? []).map((item, index) => (
              <div className={styles.rateBg} key={index}>
                <div className={styles.topRow}>
                  <div className={styles.name}>{item.nameList?.map(k => `【${k}】`).join('、')}</div>
                  <div className={styles.row}>
                    <div className={styles.label}>变压器负载率已达</div>
                    <Progress
                      type="circle"
                      size={20}
                      showInfo={false}
                      percent={LoadNum[item.type! as LoadType]}
                      strokeColor={LoadColor[item.type! as LoadType]}
                      trailColor="rgba(74,144,226,0.2)"
                    />
                    <div className={styles.percent} style={{ color: LoadColor[item.type! as LoadType] }}>
                      {LoadNum[item.type! as LoadType]}%
                    </div>
                  </div>
                </div>
                <div className={styles.desc}>{LoadText[item.type! as LoadType]}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(SchedulingPolicy);
